import { theme } from "antd";

/**
 * An indeterminate progress bar along the bottom edge of its nearest positioned ancestor, in the
 * accent colour. Renders nothing when not active, so it can stay mounted. The parent needs
 * `position: relative` (and `overflow: hidden` to follow its rounded corners).
 */
export function LoadingBar({ active }: { active: boolean }) {
	const { token } = theme.useToken();
	if (!active) return null;
	return (
		<div className="sn-loading-bar" role="progressbar" aria-label="Refreshing">
			<span style={{ background: token.colorPrimary }} />
		</div>
	);
}
